import { apiClient } from "./apiClient";
import { logger } from "./logger";

export interface UserSettings {
  trading_enabled: boolean;
}

export interface UpdateUserSettingsRequest {
  trading_enabled?: boolean;
}

export async function getUserSettings(): Promise<UserSettings> {
  try {
    const response = await apiClient.get<UserSettings>("/user/settings");
    return response.data;
  } catch (error) {
    logger.error("Error fetching user settings:", error instanceof Error ? error : new Error(String(error)));
    throw error;
  }
}

export async function updateUserSettings(
  data: UpdateUserSettingsRequest,
): Promise<UserSettings> {
  try {
    const response = await apiClient.patch<UserSettings>("/user/settings", data);
    return response.data;
  } catch (error) {
    logger.error("Error updating user settings:", error instanceof Error ? error : new Error(String(error)));
    throw error;
  }
}

